import { takeEvery } from 'redux-saga'
import { put, all, select } from 'redux-saga/effects'
import { UPDATE_FIXED_LENS } from 'actions/multiImagerActionTypes'
import { updateCameraAction } from 'actions/cameraActions'
import { updateCalculatorAction } from 'actions/calculatorActions'
import { camerasSelector } from 'selectors'
import { messageAction } from 'actions/messageActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { ValidationError } from 'helpers/validator/validator'

export function * updateFixedLens(action) {
  try {
    const { cameras } = yield select(camerasSelector)
    const { id, key, value } = action
    const { imagerId } = cameras.find(c => c.id === action.id)
    const { fixedLensIds } = cameras.find(c => c.id === imagerId)

    if (value !== '') yield all(fixedLensIds.map(lensId => lensId !== action.id && put.resolve(updateCameraAction(key, value, lensId))))
    yield put(updateCalculatorAction(value, key, id, action.fromMap))
  } catch (err) {
    if (err instanceof ValidationError) yield put(messageAction('generalError', err.message))
    else yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for update fixed lens action, then call function */
export function * watchUpdateFixedLens() {
  yield * takeEvery(UPDATE_FIXED_LENS, updateFixedLens)
}



// WEBPACK FOOTER //
// ./src/sagas/updateFixedLensSaga.js